import { render, staticRenderFns } from "./marketing-list-add-container.vue?vue&type=template&id=b9671fe2"
import script from "./marketing-list-add-container.vue?vue&type=script&lang=js"
export * from "./marketing-list-add-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports